import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const GalleryDialog = ({ open, onClose, fotos = [] }) => {

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>
                Galería de Imágenes
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {fotos.length > 0 ? (
                    <Grid container spacing={2}>
                        {fotos.map((foto, index) => (
                            <Grid item xs={12} sm={6} md={4} key={`${foto}-${index}`}>
                                <img
                                    src={`https://apifuncionesgenerales.ebtapps.com/img/${foto.replace(/\\/g, '/')}`}
                                    alt={`Foto ${index + 1}`}
                                    onError={(e) => {
                                        console.warn("Imagen rota:", e.target.src);
                                        e.target.style.display = 'none';
                                    }}
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        borderRadius: '8px',
                                        boxShadow: '0px 2px 5px rgba(0,0,0,0.2)',
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <p style={{ textAlign: 'center', width: '100%' }}>
                        No hay fotos disponibles para esta unidad.
                    </p>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GalleryDialog;